import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
// import About from '../views/About.vue'
// import News from '../views/News.vue'
// import New from '../views/New.vue'
// import Product from '../views/Product.vue'
// import Boxs from '../views/Boxs.vue'
// import Box from '../views/Box.vue'
// import Touch from '../views/Touch.vue'
// import Recruits from '../views/Recruits.vue'
// import Docs from '../views/Docs.vue'
// import Doc from '../views/Doc.vue'
import NProgress from 'nprogress'
// import HospitalIntroduction from '../views/hospitalIntroduction/index.vue'
// import HospitalNavigation from '../views/hospitalNavigation/index.vue'
// import HealthServices from '../views/healthServices/index.vue'
// import PatientServices from '../views/patientServices/index.vue'
// import NewsCenter from '../views/newsCenter/index.vue'
// import Notece from '../views/notice/index.vue'
// import SciencePopularization from '../views/sciencePopularization/index.vue'
// import DepartmentIntroduction from '../views/departmentIntroduction/index.vue'
// import ExpertIntroduction from '../views/expertIntroduction/index.vue'
import 'nprogress/nprogress.css'
// import { from } from 'core-js/core/array'

const routes = [
  // 首页路由
  {
    path: '/',
    name: 'home',
    component: Home
  },
  // 医院简介相关路由
  {
    path: '/hospitalIntroduction',
    component: () => import('@/layouts/HospitalLayout.vue'), // 使用统一布局
    children: [
      {
        path: '',
        name: 'hospitalIntroduction',
        component: () => import('@/views/hospitalIntroduction/index.vue')
      },
      {
        path: 'overview',
        name: 'hospitalIntroductionOverview',
        component: () => import('@/views/hospitalIntroduction/summarize.vue')
      },
      {
        path: 'team',
        name: 'hospitalIntroductionTeam',
        component: () => import('@/views/hospitalIntroduction/team.vue')
      },
      {
        path: 'cultrue',
        name: 'hospitalIntroductionCultrue',
        component: () => import('@/views/hospitalIntroduction/cultrue.vue')
      },
      {
        path: 'device',
        name: 'hospitalIntroductionDevice',
        component: () => import('@/views/hospitalIntroduction/device.vue')
      },
      {
        path: 'environment',
        name: 'hospitalIntroductionEnvironment',
        component: () => import('@/views/hospitalIntroduction/environment.vue')
      }
    ]
  },
  // 医院导航
  {
    path: '/hospitalNavigation',
    component: () => import('@/layouts/HospitalLayout.vue'), // 使用统一布局
    children: [
      {
        path: '',
        name: 'hospitalNavigation',
        component: () => import('@/views/hospitalNavigation/index.vue') // 默认医院概况
      },
      {
        path: 'campusDistribution',
        name: 'hospitalNavigationCampusDistribution',
        component: () => import('@/views/hospitalNavigation/campusDistribution.vue')
      },
      {
        path: 'navigation',
        name: 'hospitalNavigationNavigation',
        component: () => import('@/views/hospitalNavigation/navigation.vue')
      },
    ]
  },
  // 科室介绍
  {
    path: '/departmentIntroduction',
    component: () => import('@/layouts/HospitalLayout.vue'), // 使用统一布局
    children: [
      {
        path: '',
        name: 'departmentIntroduction',
        component: () => import('@/views/departmentIntroduction/index.vue') // 默认医院概况
      },
      {
        path: 'administrative',
        name: 'departmentIntroductionAdministrative',
        component: () => import('@/views/departmentIntroduction/administrative.vue')
      },
      // {
      //   path: '/departmentIntroduction/detail/:id/:type',
      //   name: 'DeptDetail',
      //   component: () => import('@/components/expertIntroduction/detail.vue'),
      //   props: true          // 一键把路由参数映射成组件 props，省心
      // }
      //    {
      //   path: 'detail/:id',
      //   name: 'DeptDetail',
      //   component: () => import('@/components/sonIntroduction.vue'),
      // }
    ]
  },
  // 专家介绍
  {
    path: '/expertIntroduction',
    component: () => import('@/layouts/HospitalLayout.vue'), // 使用统一布局
    children: [
      {
        path: '',
        name: 'expertIntroduction',
        component: () => import('@/views/expertIntroduction/index.vue') // 默认医院概况
      },
      {
        path: 'specialist',
        name: 'expertIntroductionSpecialist',
        component: () => import('@/views/expertIntroduction/specialist.vue')
      },
    ]
  },
  // 中医养生
  {
    path: '/healthServices',
    component: () => import('@/layouts/HospitalLayout.vue'), // 使用统一布局
    children: [
      {
        path: '',
        name: 'healthServices',
        component: () => import('@/views/healthServices/index.vue') 
      },
      {
        path: 'identification',
        name: 'healthServicesIdentification',
        component: () => import('@/views/healthServices/identification.vue')
      },
      {
        path: 'treatment',
        name: 'healthServicesTreatment',
        component: () => import('@/views/healthServices/treatment.vue')
      },
      {
        path: 'teaDrinks',
        name: 'healthServicesTeaDrinks',
        component: () => import('@/views/healthServices/teaDrinks.vue')
      },
    ]
  },
  // 患者服务
  {
    path: '/patientServices',
    component: () => import('@/layouts/HospitalLayout.vue'), // 使用统一布局
    children: [
      {
        path: '',
        name: 'patientServices',
        component: () => import('@/views/patientServices/index.vue')
      },
      {
        path: 'outpatientScheduling',
        name: 'patientServicesOutpatientScheduling',
        // component: () => import('@/views/patientServices/outpatientScheduling.vue')
        component: () => import('@/components/listIntroduction.vue')
      },
      {
        path: 'entrance',
        name: 'patientServicesEntrance',
        component: () => import('@/views/patientServices/entrance.vue')
      },
      {
        path: 'medicalInsurance',
        name: 'patientServicesMedicalInsurance',
        component: () => import('@/components/listIntroduction.vue')
      },
    ]
  },
  // 健康科普
  {
    path: '/sciencePopularization',
    component: () => import('@/layouts/HospitalLayout.vue'), // 使用统一布局
    children: [
      {
        path: '',
        name: 'sciencePopularization',
        component: () => import('@/views/sciencePopularization/index.vue') // 默认医院概况
      },
      {
        path: 'scienceEntrance',
        name: 'sciencePopularizationScienceEntrance',
        component: () => import('@/components/listIntroduction.vue')
      },
    ]
  },
  // 新闻中心
  {
    path: '/newsCenter',
    component: () => import('@/layouts/HospitalLayout.vue'), // 使用统一布局
    children: [
      {
        path: '',
        name: 'newsCenter',
        component: () => import('@/views/newsCenter/index.vue') // 默认医院概况
      },
      {
        path: 'disclosure',
        name: 'newsCenterDisclosure',
        component: () => import('@/components/listIntroduction.vue')
      },
      {
        path: 'hospitalNews',
        name: 'newsCenterHospitalNews',
        component: () => import('@/components/listIntroduction.vue')
      },
      {
        path: 'mediaFocus',
        name: 'newsCenterMediaFocus',
        component: () => import('@/components/listIntroduction.vue')
      },
    ]
  },
  // 通知公告
  {
    path: '/notice',
    component: () => import('@/layouts/HospitalLayout.vue'), // 使用统一布局
    children: [
      {
        path: '',
        name: 'notice',
        component: () => import('@/views/notice/index.vue') // 默认医院概况
      },
      {
        path: 'recruitment',
        name: 'noticeDisclosure',
        component: () => import('@/components/listIntroduction.vue')
      },
      {
        path: 'bidding',
        name: 'noticeHospitalNews',
        component: () => import('@/components/listIntroduction.vue')
      },
      {
        path: 'other',
        name: 'noticeOther',
        component: () => import('@/components/listIntroduction.vue')
      }
    ]
  },
  // router/index.js
  {
    path: '/expertIntroduction/detail/:id/:type',
    name: 'expertIntroductionDetail',
    component: () => import('@/components/expertIntroduction/detail.vue')
  },
  // 其他菜单项也采用类似结构...
  // {
  //   path: '/hospitalNavigation',
  //   name: 'hospitalNavigation',
  //   component: HospitalNavigation
  // },
  // {
  //   path: '/hospitalNavigation/overview',
  //   name: 'hospitalNavigationOverview',
  //   component: () => import('../views/hospitalNavigation/overview.vue')
  // },
  // // 中医养生
  //   {
  //   path: '/healthServices',
  //   name: 'healthServices',
  //   component: HealthServices
  // },
  // {
  //   path: '/healthServices/overview',
  //   name: 'healthServicesOverview',
  //   component: () => import('../views/healthServices/overview.vue')
  // },
  // // 患者服务
  // {
  //   path: '/patientServices',
  //   name: 'patientServices',
  //   component: PatientServices
  // },
  // {
  //   path: '/patientServices/overview',
  //   name: 'patientServicesOverview',
  //   component: () => import('../views/patientServices/overview.vue')
  // },
  // // 新闻中心
  // {
  //   path: '/newsCenter',
  //   name: 'newsCenter',
  //   component: NewsCenter
  // },
  // {
  //   path: '/NewsCenter/overview',
  //   name: 'newsCenterOverview',
  //   component: () => import('../views/newsCenter/overview.vue')
  // },
  // // 通知公告
  // {
  //   path: '/notice',
  //   name: 'notice',
  //   component: Notece
  // },
  // {
  //   path: '/notice/overview',
  //   name: 'noticeOverview',
  //   component: () => import('../views/notice/overview.vue')
  // },
  // // 健康科普
  // {
  //   path: '/sciencePopularization',
  //   name: 'sciencePopularization',
  //   component: SciencePopularization
  // },
  // {
  //   path: '/sciencePopularization/overview',
  //   name: 'sciencePopularizationOverview',
  //   component: () => import('../views/sciencePopularization/overview.vue')
  // },
  // // 科室介绍
  // {
  //   path: '/departmentIntroduction',
  //   name: 'departmentIntroduction',
  //   component: DepartmentIntroduction
  // },
  // {
  //   path: '/departmentIntroduction/overview',
  //   name: 'departmentIntroductionOverview',
  //   component: () => import('../views/departmentIntroduction/overview.vue')
  // },
  // //专家介绍
  // {
  //   path: '/expertIntroduction',
  //   name: 'expertIntroduction',
  //   component: ExpertIntroduction
  // },
  // {
  //   path: '/expertIntroduction/overview',
  //   name: 'expertIntroductionOverview',
  //   component: () => import('../views/expertIntroduction/overview.vue')
  // },


  // 404页面
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('../views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 钩子函数实现加载功能
// 前置钩子
router.beforeEach((to, from, next) => {
  NProgress.start();
  next()
})
// 后置钩子
router.afterEach((to, from, next) => {
  NProgress.done();
  // next()
})

export default router
